import script from "./PromocodeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PromocodeBanner.vue?vue&type=script&setup=true&lang=js"

import "./PromocodeBanner.vue?vue&type=style&index=0&id=4644b6fe&lang=scss"

const __exports__ = script;

export default __exports__